import { render, staticRenderFns } from "./CabinetConfiguration.vue?vue&type=template&id=28582991&"
import script from "./CabinetConfiguration.vue?vue&type=script&lang=ts&"
export * from "./CabinetConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports